import { render } from "./rpt_kardex.vue?vue&type=template&id=6dd77632"
import script from "./rpt_kardex.vue?vue&type=script&lang=js"
export * from "./rpt_kardex.vue?vue&type=script&lang=js"

import "./rpt_kardex.vue?vue&type=style&index=0&id=6dd77632&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__